package org.catharsis.TVTally

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import org.catharsis.spendtel.feature.presentation.SpendTelViewModel

@Composable
actual fun AppScaffold(content: @Composable () -> Unit) {
    Box(modifier = androidx.compose.ui.Modifier.fillMaxSize()) {
        content()
    }
}

@Composable
actual fun PlatformAppEffects(viewModel: SpendTelViewModel) {
    // Push notifications are not supported on web.
}

@Composable
actual fun ConfigureImageLoader() {
    // Coil is not required for the current web experience.
}
